
import React from 'react';

/**
 * Used to store any dom and callback that need to use editorial
 */
export const EditorialStoreContext = React.createContext();
